import { Form as AntdForm, Input } from "antd"
import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { firebaseError } from "usecases/firebase/auth"
import {
  changeEmail,
  getCurrentEmail,
} from "usecases/firebase/auth/changeEmail"

import { ErrorAlert, SuccessAlert } from "../../components/atoms/Alert"
import { Button } from "../../components/atoms/Button"
import { Spin } from "../../components/atoms/Spin"
import {
  Form,
  FormItem,
  FormItemCenter,
  FormTitle,
} from "../../components/atoms/form"
import { useInitializeAccountData } from "../../hooks/useInitializeAccountData"
import { useAsyncLoading } from "../../hooks/useLoading"

import type { ChangeEmail } from "interfaces/ChangeEmailIF"

export const MailPage = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState<string | undefined>()
  const [success, setSuccess] = useState<boolean>(false)
  const [form] = AntdForm.useForm()
  const [loading, asyncLoading] = useAsyncLoading()
  const initialize = useInitializeAccountData()

  useEffect(() => {
    asyncLoading(initialize().catch((e: any) => console.warn(e)))
  }, [])

  const onFinish = (values: unknown) => {
    console.log(form)
    console.log(values)
    const password = (values as ChangeEmail).password
    const newEmail = (values as ChangeEmail).newEmail
    if (getCurrentEmail() === newEmail) {
      setSuccess(false)
      const ErrorMes =
        "新しいメールアドレスはログイン中のアカウントのものと同一です"
      setError(ErrorMes)
      throw new Error(ErrorMes)
      return
    }
    changeEmail(password, newEmail)
      .then(() => {
        setSuccess(true)
        setError("")
        form.resetFields()
      })
      .catch((e) => {
        setSuccess(false)
        const code = firebaseError(e.code, "change-password")
        code && setError(code)
      })
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo)
    setSuccess(false)
    setError(errorInfo)
  }

  return loading ? (
    <Spin />
  ) : (
    <Form
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
      requiredMark={false}
      form={form}
    >
      <FormTitle>メールアドレス変更</FormTitle>
      <p>ログインに利用するメールアドレスを変更することができます。</p>

      <FormItem
        label="新しいメールアドレス"
        name="newEmail"
        required
        rules={[
          { required: true, message: "新しいメールアドレスを入力してください" },
        ]}
      >
        <Input type="email" placeholder="test@example.com" maxLength={100} />
      </FormItem>

      <FormItem
        label="パスワード"
        name="password"
        required
        rules={[{ required: true, message: "パスワードを入力してください" }]}
      >
        <Input.Password maxLength={100} />
      </FormItem>

      {error && <ErrorAlert>{error}</ErrorAlert>}
      {success && <SuccessAlert>メールアドレスを変更しました</SuccessAlert>}
      <FormItemCenter>
        <SaveButton isLoading={loading} className={"primary"} htmlType="submit">
          保存
        </SaveButton>
      </FormItemCenter>
    </Form>
  )
}

const SaveButton = styled(Button)`
  width: 12rem;
`
